/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Blank_FramesInputs */



/**
* | output |
* | --- |
* | "Insert blank frames" |
*
* @param {Insert_Blank_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_blank_frames = /** @type {((inputs?: Insert_Blank_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Blank_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer des images vides")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leere Rahmen einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci cornici vuote")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте пустые рамки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar marcos en blanco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入空白框架")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空白のフレームを挿入する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली फ्रेम डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira molduras em branco")
	return /** @type {LocalizedString} */ ("Insert blank frames")
});